import styled from 'styled-components'

export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-height: min(72vh, 750px);
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0 10px 0 8px;

  &::-webkit-scrollbar {
    border-radius: 20px;
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
    border-radius: 20px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.colors.secondaryL1};
    border-radius: 20px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: ${({ theme }) => theme.colors.secondaryL2};
    cursor: default;
  }
`

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const FuelTypeGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const ContactHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 0;
`

export const ContactGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const ContactTitle = styled.h3`
  ${({ theme }) => theme.fonts.infoMD};
  color: ${({ theme }) => theme.colors.neutralL5};
  margin: 0;
`

export const AddContactButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  ${({ theme }) => theme.fonts.infoMD};
  color: ${({ theme }) => theme.colors.neutralL5};
  cursor: pointer;
`

export const ContactRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`

export const ContactList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const ActionsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  > button {
    flex: 1;
  }
`
